
import { RegionState } from "@/store/region/types";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";

@Component
export default class SchoolInfo extends Vue {
  // ACTIONS
  @Action("actionSelectProvince", { namespace: "region" })
  private actionSelectProvince: any;
  @Action("actionSelectCity", { namespace: "region" })
  private actionSelectCity: any;

  // GETTERS
  @Getter("arrayCountry", { namespace: "region" })
  private arrayCountry: any;
  @Getter("arrayProvince", { namespace: "region" })
  private arrayProvince: any;
  @Getter("arrayCity", { namespace: "region" })
  private arrayCity: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: any;

  // WATCH
  @Watch("school.country")
  private onChangeCountry(country: any) {
    if (country) {
      localStorage.setItem("country", JSON.stringify(country));
    } else {
      localStorage.removeItem("country");
      localStorage.removeItem("province");
      localStorage.removeItem("city");
      this.$store.state.academy.school.province = null;
      this.$store.state.academy.school.city = null;
    }
  }

  @Watch("school.province")
  private onChangeProvince(province: any) {
    if (province) {
      localStorage.setItem("province", JSON.stringify(province));
    } else {
      localStorage.removeItem("province");
      localStorage.removeItem("city");
      this.$store.state.academy.school.city = null;
    }
  }

  @Watch("school.city")
  private onChangeCity(city: any) {
    if (city) {
      localStorage.setItem("city", JSON.stringify(city));
    } else {
      localStorage.removeItem("city");
    }
  }

  @Watch("school.postal_code")
  private onChangePostalCode(postal_code: any) {
    if (postal_code) {
      localStorage.setItem("postal_code", postal_code);
    }
  }

  @Watch("school.address")
  private onChangeAddress(address: any) {
    if (address) {
      localStorage.setItem("address", address);
    }
  }

  @Watch("school.email")
  private onChangeEmail(email: any) {
    if (email) {
      localStorage.setItem("email_company", email);
    }
  }

  @Watch("school.phone")
  private onChangePhone(phone: any) {
    if (phone) {
      localStorage.setItem("phone_company", phone);
    }
  }

  private created() {
    const country = localStorage.getItem("country");
    const province = localStorage.getItem("province");
    const city = localStorage.getItem("city");
    const postal_code = localStorage.getItem("postal_code");
    const address = localStorage.getItem("address");
    const email = localStorage.getItem("email_company");
    const phone = localStorage.getItem("phone_company");
    if (country !== null) {
      this.$store.state.academy.school.country = JSON.parse(country);
      this.loadProvince(JSON.parse(country));
    }
    if (province !== null) {
      this.$store.state.academy.school.province = JSON.parse(province);
      this.loadCity(JSON.parse(province));
    }
    if (city !== null) {
      this.$store.state.academy.school.city = JSON.parse(city);
    }
    if (postal_code !== null) {
      this.$store.state.academy.school.postal_code = postal_code;
    }
    if (address !== null) {
      this.$store.state.academy.school.address = address;
    }
    if (email !== null) {
      this.$store.state.academy.school.email = email;
    }
    if (phone !== null) {
      this.$store.state.academy.school.phone = phone;
    }
  }

  // METHOD
  private loadProvince(country: any) {
    if (country) {
      this.school.country = country;
      this.actionSelectProvince(country);
    }
  }

  private loadCity(province: any) {
    if (province) {
      this.school.province = province;
      this.actionSelectCity(province);
    }
  }
}
